// const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
const baseURL = process.env.REACT_APP_API_URL || "https://api-easysuite.bakeli.tech/api";

export async function httpRequest(
  path,
  { method = "GET", headers = {}, body } = {}
) {
  const response = await fetch(`${baseURL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
    credentials: "include",
  });
  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `HTTP ${response.status}`);
  }
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) return response.json();
  return response.text();
}

export const api = {
  auth: {
    login: (payload) =>
      httpRequest("/auth/login", { method: "POST", body: payload }),
    register: (payload) =>
      httpRequest("/auth/register", { method: "POST", body: payload }),
    me: () => httpRequest("/user"),
    logout: () => httpRequest("/auth/logout", { method: "POST" }),
    forgotPassword: (payload) =>
      httpRequest("/auth/forgot-password", { method: "POST", body: payload }),
    resetPassword: (payload) =>
      httpRequest("/auth/reset-password", { method: "POST", body: payload }),
  },
};
